module.exports = __webpack_public_path__ + "img/img-avatar.267f6d05.svg";